import { useEffect, useState, useRef } from 'react';
import styles from './mainInformation.module.css';
import { Link } from 'react-router-dom';

function MainInformation() {
    const [newsItems, setNewsItems] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [visibleIndex, setVisibleIndex] = useState(0);
    const [isFading, setIsFading] = useState(false);

    const intervalRef = useRef(null);
    const isHoveredRef = useRef(false);

    useEffect(() => {
        fetch('/api/news/get_news_carousel_highlighted')
            .then(res => res.json())
            .then(data => {
                setNewsItems(data);
            })
            .catch(err => console.error("Failed to fetch highlighted news:", err));
    }, []);

    const startAutoRotate = () => {
        intervalRef.current = setInterval(() => {
            setSelectedIndex(prev => {
                const next = (prev + 1) % newsItems.length;
                triggerTransition(next);
                return next;
            });
        }, 7500);
    };

    const resetAutoRotate = () => {
        clearInterval(intervalRef.current);
        // Use the ref here, not state:
        if (!isHoveredRef.current && newsItems.length > 1) {
            startAutoRotate();
        }
    };

    useEffect(() => {
        if (newsItems.length > 1) {
            startAutoRotate();
        }
        return () => clearInterval(intervalRef.current);
    }, [newsItems, startAutoRotate]);

    const triggerTransition = (newIndex) => {
        setIsFading(true);
        setTimeout(() => {
            setVisibleIndex(newIndex);
            setIsFading(false);
        }, 300);
    };

    const handleClick = (index) => {
        setSelectedIndex(index);
        triggerTransition(index);
        resetAutoRotate();
    };

    const current = newsItems[visibleIndex];

    if (!current) return (
        <div className={styles.container}><p>Probleme beim Laden der Nachrichten</p></div>
    ); // or a loading spinner

    return (
        <div className={styles.container}
            onMouseEnter={() => {
                isHoveredRef.current = true;  // update ref
                clearInterval(intervalRef.current);
            }}
            onMouseLeave={() => {
                isHoveredRef.current = false; // update ref
                if (newsItems.length > 1) startAutoRotate();
            }}
        >
            <div className={`${styles.mainContent} ${newsItems.length > 1 ? styles.mainContentWithSelector : ''}`}>
                <div className={`${styles.contentWrapper} ${isFading ? styles.fadeOut : styles.fadeIn}`}>
                    <div
                        className={`${styles.imageWrapper} ${newsItems.length === 1 ? styles.roundLeftFull : styles.roundLeftTop}`}
                    >
                        <img
                            src={current.image}
                            alt={current.altText}
                            className={styles.image}
                        />
                        <div className={styles.imageOverlay} />
                    </div>
                    <div className={styles.textContainer}>
                        <h2>
                            <Link to={`/news/${current.slug}`}>
                                {current.title}
                            </Link>
                        </h2>
                        <div dangerouslySetInnerHTML={{ __html: current.highlight_html }} />
                        {/* <p className={styles.date}><small>{current.published_date}</small></p> */}
                    </div>
                </div>
            </div>

            {newsItems.length > 1 && (
                <div className={styles.selector}>
                    {newsItems.map((item, index) => (
                        <button
                            key={index}
                            className={`${styles.selectorItem} ${index === selectedIndex ? styles.active : ''}`}
                            onClick={() => handleClick(index)}
                        >
                            {item.title}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MainInformation;
